import { styles } from "@repo/helpers";
import { Button, ButtonTypes } from "@repo/ui";
import { X } from "lucide-react";

interface PanelHeaderProps {
	title: string;
	titleId?: string;
	onClose: () => void;
	className?: string;
	closeClassName?: string;
}

export function PanelHeader({ title, titleId, onClose, className, closeClassName }: PanelHeaderProps) {
	return (
		<div
			className={styles("flex h-14 shrink-0 items-center justify-between border-b border-border px-3", className)}
		>
			<h2
				id={titleId}
				className="mb-0 text-xs font-semibold uppercase tracking-wider text-muted-foreground lg:mb-2"
			>
				{title}
			</h2>
			<Button
				types={[ButtonTypes.Text]}
				onClick={onClose}
				aria-label={`Close ${title}`}
				className={styles("flex h-11 w-11 items-center justify-center", closeClassName)}
			>
				<X className="h-5 w-5" />
			</Button>
		</div>
	);
}
